import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ISetting } from '@/types/components/setting';
import { CHECKOUT_PAGE_OPTION, DELIVERY_RESTRICTION_CHOICE, DELIVERY_RESTRICTION_CUSTOM } from '@/constants/enum';

const settingInitial: ISetting = {
  timezone: 'Default buyer timezone',
  isRequiredBeforeCheckout: false,
  isShowOnProductPage: true,
  showMapOnWidget: false,
  dateTimeOnPackingSlip: true,
  includeNonWorkDayInPrep: false,
  kindOfOverrideRules: 'earliest',
  googleMapApiKey: '',
  shop: '',
  googleCalendarTimeSlot: '',
  isEnableOrderTag: false,
  isAutoFillPickupAddress: true,
  isModifiedPickupAddress: true,
  isChangeMethodShipping: CHECKOUT_PAGE_OPTION.OFF,
  isDisableCheckoutButton: false,
  isDisableAddToCartButton: false,
  manualSelectorBlockCheckoutButton: '',
  manualSelectorBlockAddToCartButton: '',
  deliveryRestrictionType: DELIVERY_RESTRICTION_CHOICE.POSTAL_CODE_MATCH,
  deliveryDistanceUnit: DELIVERY_RESTRICTION_CUSTOM.KM,
  googleRoutesApiKey: '',
  isEnableGoogleMap: false,
  displayOnPage: [],
  orderTag: [],
  isAutoFillDeliveryZipCode: false,
};

const initialState = {
  generalSetting: settingInitial,
  generalBackupSetting: settingInitial,
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    handleSaveSettings: (state, action: PayloadAction<Partial<ISetting>>) => {
      state.generalSetting = { ...state.generalSetting, ...action.payload };
    },
    handleSaveBackupSettings: (state, action: PayloadAction<Partial<ISetting>>) => {
      state.generalBackupSetting = { ...state.generalBackupSetting, ...action.payload };
    },
    handleResetSettings: (state) => {
      state.generalSetting = state.generalBackupSetting;
    },
  },
});

export const generalSettingSelector = createSelector(
  (state: RootState) => state.setting,
  (state) => state.generalSetting,
);
export const generalBackupSettingSelector = createSelector(
  (state: RootState) => state.setting,
  (state) => state.generalBackupSetting,
);

export const { handleSaveSettings, handleSaveBackupSettings, handleResetSettings } = settingSlice.actions;

export default settingSlice;
